export enum UserRoles {
  Administrator = "Administrator",
  Publisher = "Publisher",
  Reviewer = "Reviewer"
}
